import { render, staticRenderFns } from "./TwitterButton.vue?vue&type=template&id=71d82302&scoped=true&lang=pug&"
import script from "./TwitterButton.vue?vue&type=script&lang=js&"
export * from "./TwitterButton.vue?vue&type=script&lang=js&"
import style0 from "./TwitterButton.vue?vue&type=style&index=0&id=71d82302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d82302",
  null
  
)

export default component.exports